import { FC } from 'react';
import { SCUIContent } from "../../../atomic/organisms";
import { SCUIProductCommentDetailForm } from "../../../atomic/molecules";
import { useLocation } from "react-router-dom";
import { CD } from './commentDetail.classes';

export const CommentDetail: FC<any> = (props: any) => {
  const query = new URLSearchParams(useLocation().search);
  const idfromUrl = query.get("CommentId");
  const id = props.history.location.state?.id
    ? props.history.location.state?.id
    : idfromUrl;

  return (
    <SCUIContent className={CD.page}>
      <div className={CD.formSection}>
        <SCUIProductCommentDetailForm id={id} history={props.history} />
      </div>
    </SCUIContent>
  );
};
